import moment from 'moment'
import IQuestion from '../interfaces/IQuestion'

export const QUESTION_TYPES = {
  FILE: 'file',
  LONG_TEXT: 'long_text',
  RADIO: 'radio',
  SHORT_TEXT: 'short_text',
}

export const GENERAL_QUESTION = [
  {
    title:
      '1. ขอให้น้องเล่าเรื่องที่ตนเองเคยทำพลาดหรือผิดหวังในอดีตมาหนึ่งอย่าง ตอนนั้นเกิดอะไรขึ้นและน้องได้เรียนรู้อะไรจากเหตุการณ์นั้นบ้าง ถ้าในอนาคตน้องต้องรับมือกับเรื่องเดียวกันนี้อีกครั้ง น้องจะเปลี่ยนแปลงหรือแก้ไขสิ่งที่เกิดขึ้นอย่างไรให้ได้ผลลัพธ์ที่ต่างจากเดิม',
    type: QUESTION_TYPES.LONG_TEXT,
  },
  {
    title:
      '2. อะไรคือสิ่งที่น้องภูมิใจหรือประทับใจในตนเองที่สุด นำเสนอความเป็นตัวเองได้เต็มที่เลย',
    type: QUESTION_TYPES.LONG_TEXT,
  },
]

export const MAJOR_QUESTION = (major: string = 'content'): IQuestion[] => {
  // TODO: replace with major enum
  switch ((major ?? '').toLowerCase()) {
    case 'content':
      return [
        {
          title: `ตอนนี้คุณได้เป็น Content Manager ผู้สร้างคอนเทนต์ให้กับพรรคการเมือง "ก้าวเพื่อพลังประชาภูมิใจกล้ารวมธิปัตย์" มติประชุมพรรคได้กำหนดให้สร้างคอนเทนต์โปรโมท "คุณ A" ผู้สมัครชิงตำแหน่งนายกรัฐมนตรีของพรรค โดยคอนเทนต์นี้ถือเป็น Hero Content ที่จะถูกใช้ไปตลอดแคมเปญ ซึ่งจะต้องมี<br />
          <li>แนะนำผู้สมัคร</li>
          <li>นโยบาย</li>
          <li>สิ่งที่แตกต่างจากพรรคอื่น</li>
          <li>เบอร์ของพรรค</li>
          <br />
          โดยคอนเทนต์นี้ จะเน้นชู "คุณ A" เพื่อเป็นนายกรัฐมนตรีเป็นหลัก ซึ่งยังไม่ได้เป็นที่รู้จักของคนทั้งประเทศมากนัก ทางพรรคคาดหวังว่าคอนเทนต์นี้จะมีความคิดสร้างสรรค์ และแปลกใหม่ เพื่อชูให้คนทั้งประเทศได้สนใจเลือกผู้สมัครมากขึ้น
          <br /><br />
          เงื่อนไข: คุณ A เป็นตัวละครในจินตนาการ จะเป็นเพศใดก็ได้, อายุ, สถานะ, อาชีพ, การศึกษา, นโยบาย สามารถสร้างสรรค์ได้ตามที่ต้องการ (คะแนนจะดูจากการสร้างสรรค์คอนเทนต์เป็นหลัก)
          <br /><br />
          1.1. ทำคอนเทนต์เพื่ออธิบาย ในลักษณะ Format ใดก็ได้ 1 อย่างที่ตนถนัด เช่น
          <li>บล็อก, บทความแบบยาว, บทวิเคราะห์</li>
          <li>วิดีโอสั้นแบบ TikTok, Reels, YouTube Short</li>
          <li>Facebook Post (ใช้ภาพประกอบคำอธิบาย อัลบัม หรืออินโฟกราฟฟิก)</li>
`,
        },
        {
          title:
            '1.2. เขียนอธิบายเหตุผลว่าทำไมถึงเลือกใช้ Format นั้น วิเคราะห์ในมุมของการทำคอนเทนต์ มีข้อดีหรือข้อเสียอย่างไร',
        },
        {
          title:
            '2. จากจำนวนที่คนสมัครมาทั้งหมดหลายร้อยคน จุดแข็งอะไรที่ทำให้น้องคิดว่าตัวเองควรได้รับเลือกเข้าร่วมค่าย YWC ในปีนี้ สำหรับสาขาคอนเทนต์',
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'content',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))

    case 'design':
      return [
        {
          title:
            '1. ให้ผู้สมัครสาขา Design อธิบายว่าประสบการณ์ของมนุษย์มีความสัมพันธ์อย่างไรกับความยั่งยืน (Sustainability) และจากการตีความ ผู้สมัครจะสามารถถ่ายทอดแนวคิดนั้นออกมาเป็นรูปแบบของงานออกแบบ UI ได้อย่างไร พร้อมยกตัวอย่าง',
          type: QUESTION_TYPES.LONG_TEXT,
        },
        {
          title:
            '2. จงบอกข้อดีและข้อเสียของเทคโนโลยี A.I. สำหรับช่วยงานออกแบบในยุคปัจจุบัน',
          type: QUESTION_TYPES.LONG_TEXT,
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'design',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))
    case 'marketing':
      return [
        {
          title:
            '1. จงอธิบายความรู้และประสบการณ์ทางด้านสาขาวิชาการตลาดที่น้องมี โดยแยกการตลาดออฟไลน์และการตลาดออนไลน์ให้ชัดเจน หากได้รับเลือกสัมภาษณ์ ให้นำเอกสารหรือหลักฐานยืนยันของสิ่งที่ตอบมาแสดงด้วย',
          type: QUESTION_TYPES.LONG_TEXT,
        },
        { title: '', optional: true, type: QUESTION_TYPES.FILE },
        {
          title:
            '2. เพราะเหตุใดน้องจึงควรได้รับเลือกเข้าร่วมค่าย YWC ในปีนี้ สำหรับสาขาการตลาด',
          type: QUESTION_TYPES.LONG_TEXT,
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'marketing',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))
    case 'programming':
      return [
        {
          title:
            '1. จงเลือก Technology, Tools, หรือภาษาที่เกี่ยวกับการเขียนโปรแกรมมาหนึ่งอย่างที่อยากให้กรรมการได้ “ลองใช้” (ป้ายยา) และเขียนอธิบายว่าสิ่งสิ่งนั้นคืออะไร ทำไมจึงอยากให้กรรมการได้ลองใช้',
        },
        {
          title:
            '2. งาน Programming งานไหนในชีวิตของคุณที่คุณภูมิใจที่สุด และทำไมถึงภูมิใจในงานนั้น อยากให้ผู้สมัครเล่าให้พวกเราฟัง',
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'programming',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))
    default:
      return []
  }
}

interface MajorDetail {
  color: string
  name: string
  value: string
}

export const MAJOR = (major: string): string => {
  // TODO: replace with major enum
  const majors = [
    {
      color: 'purple',
      name: 'Content',
      value: 'content',
    },
    {
      color: 'magenta',
      name: 'Design',
      value: 'design',
    },
    {
      color: 'volcano',
      name: 'Web Marketing',
      value: 'marketing',
    },
    {
      color: 'geekblue',
      name: 'Web Programming',
      value: 'programming',
    },
  ]

  const result = majors.find(
    (m: MajorDetail) => m.value === (major ?? '').toLowerCase()
  ) || {
    name: '',
  }

  return result.name
}

export const DEADLINE = import.meta.env.VITE_APP_REGISTRATION_DEADLINE
export const OPENDATE = import.meta.env.VITE_APP_REGISTRATION_OPEN
export const RESULT_DATE = '3 พฤษภาคม 2568'
export const INTERVIEW_ANNOUNCEMENT_AFTER = import.meta.env
  .VITE_APP_INTERVIEW_ANNOUNCEMENT_AFTER
export const REGISTRATION_OPEN =
  moment().isAfter(OPENDATE) && moment().isBefore(DEADLINE)
export const INTERVIEW_ANNOUNCEMENT_OPEN = moment().isAfter(
  INTERVIEW_ANNOUNCEMENT_AFTER
)

export const FINALIST_ANNOUNCEMENT_AFTER = import.meta.env
  .VITE_APP_FINALIST_ANNOUNCEMENT_AFTER
export const FINALIST_ANNOUNCEMENT_OPEN = moment().isAfter(
  FINALIST_ANNOUNCEMENT_AFTER
)

export const ALLOWED_TO_LOGIN =
  REGISTRATION_OPEN || INTERVIEW_ANNOUNCEMENT_OPEN || FINALIST_ANNOUNCEMENT_OPEN

export const FORCE_CLOSE = import.meta.env.VITE_APP_FORCE_CLOSE === 'true'

export const ALLOW_BIRTHDATE = {
  MAX: '1/1/1900',
  MIN: '1/1/3000',
}
